import { Component } from 'vue-property-decorator';
import ContactTagTable from '../../components/tables/contact-tag-table/contact-tag-table.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-contact-tags',
  components: {
    'bpc-contact-tag-table': ContactTagTable,
  },
})
export default class ContactTags extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
